(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver_tailwind_search = {
    
    replaceSearchLinkUrl: function() {
      const searchLink = document.querySelector('[data-ptb-link="search"]');

      if (searchLink == null || window.location.search == '') {
        return;
      }

      const currentUrl = new URL(window.location.href);

      let searchParam = currentUrl.searchParams.get('search');

      if (searchParam == null) {
        return;
      }

      const href = searchLink.href;
      searchLink.setAttribute('href', href + '?search=' + searchParam);
    },

    replaceSearchTermPlaceholder: function() {
      // inserts search term into results header
      const searchHeader = document.querySelector('.view-solr-search header');

      if (searchHeader == null) {
        return;
      }
      const searchParams = new URLSearchParams(window.location.search);

      if (searchParams.has('search')) {
        searchHeader.innerHTML = searchHeader.innerHTML.replace('{{search_term}}', '"' + searchParams.get('search') + '"');
      } else {
        searchHeader.innerHTML = searchHeader.innerHTML.replace('{{search_term}}', 'no search');
      }
    },

    scrollFilters: function() {
      const searchResults = document.getElementById('search-results');
      
      if (searchResults == null || window.location.search == '') {
        return;
      }

      setTimeout(() => {
        searchResults.scrollIntoView();
      }, 500);
    },

    attach: function (context, settings) {

      $(once('weaver_tailwind_search', 'body', context)).each(function () {

        const weaver_tailwind_search = Drupal.behaviors.weaver_tailwind_search;
        weaver_tailwind_search.replaceSearchLinkUrl();
        weaver_tailwind_search.replaceSearchTermPlaceholder();
        weaver_tailwind_search.scrollFilters();
      });
    }
  };
})(jQuery, Drupal, once);